@if (allowSavedViews && savedViews.enabled) {
  <app-saved-views [filters]="searchForm.getRawValue()" [context]="viewContext" (viewSelected)="applySavedView($event)"></app-saved-views>
}
<div class="search-engine" (click)="$event.stopPropagation()">
  <form [formGroup]="searchForm">

    <!-- Champs cachés -->
    <ng-container *ngFor="let field of hiddenFields">
      <input type="hidden" [formControlName]="field.name" [value]="field.defaultValue" />
    </ng-container>

    <!-- Ligne unique : champ de recherche principal + chips de filtres -->
    <div class="filters-row">

      <!-- Champ de recherche principal (inline, style chip) -->
      <div *ngIf="mainField" class="search-chip-wrapper">
        <i class="fas fa-search search-chip-icon"></i>
        <input
          type="text"
          class="search-chip-input"
          [formControlName]="mainField.name"
          [placeholder]="mainField.label | translate"
        />
        <button
          *ngIf="hasValue(mainField.name)"
          type="button"
          class="search-chip-clear"
          (click)="clearField($event, mainField.name)"
          title="Effacer"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Chips de filtres -->
      <ng-container *ngIf="filterFields.length > 0">
        <div class="chips-list">

        <ng-container *ngFor="let field of visibleFilterFields">
          <!-- Wrapper avec position:relative pour ancrer le panel -->
          <div class="chip-wrapper">

            <!-- Groupe chip + bouton effacer -->
            <div class="chip-group" [class.chip-group--active]="hasValue(field.name)">
              <button
                type="button"
                class="chip-btn"
                [class.chip-btn--open]="activeChip === field.name"
                (click)="toggleChip(field.name, $event)"
              >
                <span class="chip-label">
                  <ng-container *ngIf="hasValue(field.name); else placeholder">
                    <ng-container *ngIf="isResolvingValue(field.name); else loaded">
                      <span class="chip-value chip-value--loading" aria-busy="true">
                        <span class="chip-skeleton"></span>
                      </span>
                    </ng-container>
                    <ng-template #loaded>
                      <span
                        class="chip-value"
                        [ngbTooltip]="chipTooltipText(field.name)"
                        tooltipClass="chip-values-tooltip"
                        container="body"
                        placement="bottom"
                        [openDelay]="200"
                      >{{ getValueLabel(field.name) }}</span>
                    </ng-template>
                  </ng-container>
                  <ng-template #placeholder>{{ field.label | translate }}</ng-template>
                </span>
                <i class="fas chip-arrow"
                   [class.fa-chevron-down]="activeChip !== field.name"
                   [class.fa-chevron-up]="activeChip === field.name">
                </i>
              </button>

              <button
                *ngIf="canClearField(field)"
                type="button"
                class="chip-clear"
                (click)="clearField($event, field.name)"
                title="Effacer"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>

            <!-- Panel du chip, ancré sous le chip lui-même -->
            <div
              class="chip-panel"
              [hidden]="activeChip !== field.name"
              (click)="$event.stopPropagation()"
            >
              <ng-container [ngSwitch]="field.type">

                <!-- Entité (single ou multi) — labels venant de l'API, pas de traduction -->
                <app-dropdown-select
                  *ngSwitchCase="'entity'"
                  [apiUrl]="field.apiEndpoint"
                  [apiFilters]="field.apiFilters ?? {}"
                  [includeInactiveUserFirms]="field.includeInactiveUserFirms === true"
                  [defaultValue]="formControls[field.name].value"
                  [formControlName]="field.name"
                  [isMultiSelect]="field.multiple"
                  [autoEmitChanges]="!field.multiple"
                  [hideValidateButton]="!field.multiple"
                  [capitalizeLabel]="field.capitalizeLabel ?? false"
                  [excludeIds]="field.excludeIds ?? []"
                  [itemsPerPage]="field.itemsPerPage ?? 100"
                  [placeHolder]="field.label | translate"
                  [itemValueKey]="field.optionValue ?? 'id'"
                  [itemLabelKey]="field.optionName ?? 'name'"
                  [searchKey]="field.searchKey ?? 'name'"
                  [clearable]="field.clearable !== false"
                  [inlineList]="true"
                  [maxHeight]="480"
                  (onSelectionChange)="onDropdownSelectionChange(field.name)"
                  (onValidateSelection)="onDropdownValidate(field.name)"
                ></app-dropdown-select>

                <!-- Multi-select statique — labels peuvent être des clés i18n -->
                <app-dropdown-select
                  *ngSwitchCase="'multiselect'"
                  [defaultValue]="formControls[field.name].value"
                  [formControlName]="field.name"
                  [inputItems]="field.options"
                  [isMultiSelect]="field.multiple"
                  [autoEmitChanges]="!field.multiple"
                  [hideValidateButton]="!field.multiple"
                  [translateLabels]="true"
                  [placeHolder]="field.label | translate"
                  [itemValueKey]="field.optionValue || 'value'"
                  [itemLabelKey]="field.optionName || 'label'"
                  [searchKey]="'label'"
                  [clearable]="field.clearable !== false"
                  [inlineList]="true"
                  [maxHeight]="480"
                  (onSelectionChange)="onDropdownSelectionChange(field.name)"
                  (onValidateSelection)="onDropdownValidate(field.name)"
                ></app-dropdown-select>

                <!-- Select — toujours single, ferme dès la sélection -->
                <app-dropdown-select
                  *ngSwitchCase="'select'"
                  [defaultValue]="formControls[field.name].value"
                  [formControlName]="field.name"
                  [inputItems]="field.options"
                  [isMultiSelect]="false"
                  [autoEmitChanges]="true"
                  [hideValidateButton]="true"
                  [translateLabels]="true"
                  [placeHolder]="field.label | translate"
                  [itemValueKey]="field.optionValue || 'value'"
                  [itemLabelKey]="field.optionName || 'label'"
                  [searchKey]="'label'"
                  [clearable]="field.clearable !== false"
                  [inlineList]="true"
                  [maxHeight]="480"
                  (onSelectionChange)="onDropdownSelectionChange(field.name)"
                ></app-dropdown-select>

                <!-- Texte -->
                <input
                  *ngSwitchCase="'text'"
                  type="text"
                  class="form-control"
                  [formControlName]="field.name"
                  [placeholder]="field.label | translate"
                />

                <!-- Nombre -->
                <input
                  *ngSwitchCase="'number'"
                  type="number"
                  class="form-control"
                  [formControlName]="field.name"
                  [placeholder]="field.label | translate"
                />

                <!-- Date -->
                <div *ngSwitchCase="'date'" class="input-group date-input-group">
                  <input
                    class="form-control"
                    [formControlName]="field.name"
                    [placeholder]="field.label | translate"
                    ngbDatepicker
                    #dd="ngbDatepicker"
                  />
                  <button class="btn btn-date-icon" type="button" (click)="dd.toggle()">
                    <i class="fas fa-calendar-alt"></i>
                  </button>
                </div>

                <!-- Checkbox -->
                <div *ngSwitchCase="'checkbox'" class="form-check p-2">
                  <input
                    type="checkbox"
                    [id]="field.name"
                    class="form-check-input"
                    [formControlName]="field.name"
                  />
                  <label [for]="field.name" class="form-check-label ms-2">
                    {{ field.placeholder }}
                  </label>
                </div>

              </ng-container>
            </div>
            <!-- /chip-panel -->

          </div>
          <!-- /chip-wrapper -->
        </ng-container>

        <ng-template #moreFiltersTip>
          <div class="more-filters-tip">
            <div class="more-filters-tip__title">Filtres</div>
            <ul class="more-filters-tip__list">
              <li *ngFor="let item of hiddenFiltersTooltip">
                {{ item.label }}<span *ngIf="item.value" class="more-filters-tip__value"> : {{ item.value }}</span>
              </li>
            </ul>
          </div>
        </ng-template>

        <button
          *ngIf="hiddenFilterCount > 0 || showMore"
          type="button"
          class="chip-btn chip-btn--more"
          [ngbTooltip]="showMore ? null : moreFiltersTip"
          container="body"
          placement="bottom"
          [openDelay]="200"
          (click)="toggleShowMore(); $event.stopPropagation()"
        >
          <i class="fas" [class.fa-plus]="!showMore" [class.fa-minus]="showMore"></i>
          <span class="ms-1">
            {{ showMore ? 'Moins' : (hiddenFilterCount + ' filtres') }}
          </span>
        </button>

        <ng-container *ngIf="showMore">
        <ng-container *ngFor="let field of extraFilterFields">
          <div class="chip-wrapper">

            <div class="chip-group" [class.chip-group--active]="hasValue(field.name)">
              <button
                type="button"
                class="chip-btn"
                [class.chip-btn--open]="activeChip === field.name"
                (click)="toggleChip(field.name, $event)"
              >
                <span class="chip-label">
                  <ng-container *ngIf="hasValue(field.name); else extraPlaceholder">
                    <ng-container *ngIf="isResolvingValue(field.name); else extraLoaded">
                      <span class="chip-value chip-value--loading" aria-busy="true">
                        <span class="chip-skeleton"></span>
                      </span>
                    </ng-container>
                    <ng-template #extraLoaded>
                      <span
                        class="chip-value"
                        [ngbTooltip]="chipTooltipText(field.name)"
                        tooltipClass="chip-values-tooltip"
                        container="body"
                        placement="bottom"
                        [openDelay]="200"
                      >{{ getValueLabel(field.name) }}</span>
                    </ng-template>
                  </ng-container>
                  <ng-template #extraPlaceholder>{{ field.label | translate }}</ng-template>
                </span>
                <i class="fas chip-arrow"
                   [class.fa-chevron-down]="activeChip !== field.name"
                   [class.fa-chevron-up]="activeChip === field.name">
                </i>
              </button>

              <button
                *ngIf="canClearField(field)"
                type="button"
                class="chip-clear"
                (click)="clearField($event, field.name)"
                title="Effacer"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>

            <div
              class="chip-panel"
              [hidden]="activeChip !== field.name"
              (click)="$event.stopPropagation()"
            >
              <ng-container [ngSwitch]="field.type">

                <app-dropdown-select
                  *ngSwitchCase="'entity'"
                  [apiUrl]="field.apiEndpoint"
                  [apiFilters]="field.apiFilters ?? {}"
                  [includeInactiveUserFirms]="field.includeInactiveUserFirms === true"
                  [defaultValue]="formControls[field.name].value"
                  [formControlName]="field.name"
                  [isMultiSelect]="field.multiple"
                  [autoEmitChanges]="!field.multiple"
                  [hideValidateButton]="!field.multiple"
                  [capitalizeLabel]="field.capitalizeLabel ?? false"
                  [excludeIds]="field.excludeIds ?? []"
                  [itemsPerPage]="field.itemsPerPage ?? 100"
                  [placeHolder]="field.label | translate"
                  [itemValueKey]="field.optionValue ?? 'id'"
                  [itemLabelKey]="field.optionName ?? 'name'"
                  [searchKey]="field.searchKey ?? 'name'"
                  [clearable]="field.clearable !== false"
                  [inlineList]="true"
                  [maxHeight]="480"
                  (onSelectionChange)="onDropdownSelectionChange(field.name)"
                  (onValidateSelection)="onDropdownValidate(field.name)"
                ></app-dropdown-select>

                <app-dropdown-select
                  *ngSwitchCase="'multiselect'"
                  [defaultValue]="formControls[field.name].value"
                  [formControlName]="field.name"
                  [inputItems]="field.options"
                  [isMultiSelect]="field.multiple"
                  [autoEmitChanges]="!field.multiple"
                  [hideValidateButton]="!field.multiple"
                  [translateLabels]="true"
                  [placeHolder]="field.label | translate"
                  [itemValueKey]="field.optionValue || 'value'"
                  [itemLabelKey]="field.optionName || 'label'"
                  [searchKey]="'label'"
                  [clearable]="field.clearable !== false"
                  [inlineList]="true"
                  [maxHeight]="480"
                  (onSelectionChange)="onDropdownSelectionChange(field.name)"
                  (onValidateSelection)="onDropdownValidate(field.name)"
                ></app-dropdown-select>

                <app-dropdown-select
                  *ngSwitchCase="'select'"
                  [defaultValue]="formControls[field.name].value"
                  [formControlName]="field.name"
                  [inputItems]="field.options"
                  [isMultiSelect]="false"
                  [autoEmitChanges]="true"
                  [hideValidateButton]="true"
                  [translateLabels]="true"
                  [placeHolder]="field.label | translate"
                  [itemValueKey]="field.optionValue || 'value'"
                  [itemLabelKey]="field.optionName || 'label'"
                  [searchKey]="'label'"
                  [clearable]="field.clearable !== false"
                  [inlineList]="true"
                  [maxHeight]="480"
                  (onSelectionChange)="onDropdownSelectionChange(field.name)"
                ></app-dropdown-select>

                <input
                  *ngSwitchCase="'text'"
                  type="text"
                  class="form-control"
                  [formControlName]="field.name"
                  [placeholder]="field.label | translate"
                />

                <input
                  *ngSwitchCase="'number'"
                  type="number"
                  class="form-control"
                  [formControlName]="field.name"
                  [placeholder]="field.label | translate"
                />

                <div *ngSwitchCase="'date'" class="input-group date-input-group">
                  <input
                    class="form-control"
                    [formControlName]="field.name"
                    [placeholder]="field.label | translate"
                    ngbDatepicker
                    #ddExtra="ngbDatepicker"
                  />
                  <button class="btn btn-date-icon" type="button" (click)="ddExtra.toggle()">
                    <i class="fas fa-calendar-alt"></i>
                  </button>
                </div>

                <div *ngSwitchCase="'checkbox'" class="form-check p-2">
                  <input
                    type="checkbox"
                    [id]="field.name"
                    class="form-check-input"
                    [formControlName]="field.name"
                  />
                  <label [for]="field.name" class="form-check-label ms-2">
                    {{ field.placeholder }}
                  </label>
                </div>

              </ng-container>
            </div>

          </div>
        </ng-container>
        </ng-container>

      </div>
      </ng-container>
      <!-- /chips de filtres -->

    </div>
    <!-- /filters-row -->

  </form>
</div>
